import React from 'react';
import { fontFamiliesToGoogleFontsUrl, notoIconsFont } from './fonts';

export function NotoIconsLoader() {
  return <link href={fontFamiliesToGoogleFontsUrl([notoIconsFont])} rel="stylesheet" />;
}
